export default {
  erase: '消去',
  eraseComponent: '消去コンポーネント',
  eraseSetting: '消去設定',
  onlyOneTip: '同じシーンには、消去コンポーネントを1つしか追加できません。',
  isEnable: 'コンポーネントを有効化',
  enableText: '有効',
  disableText: '無効',
  brush: {
    title: '消しゴムストローク設定',
    brushStyle: 'ストロークスタイル',
    round: '円形',
    rect: '矩形',
    pic: '画像認識',
    size: 'サイズ',
    scale: 'スケール比率',
    rotation: '回転角度',
    picDesc: '画像ファイル：png、＜1M',
    seqDesc: 'シーケンスフレームファイル：zip（png）、＜8M',
    addTip: 'ストロークスタイルを識別する画像を選択してください。',
    picTip: '画像内の有効なピクセルをストロークとして認識します。',
    seqTip: 'シーケンスの最初のフレームをストロークとして認識します。',
    handImage: '指に従う画像',
    handImageTip: '消去中の指の移動に追従する消去ストローク画像',
    hangImageDialog: {
      title: '外観',
      pivot: '指に従うアンカーポイント',
      pivotDesc:
        '緑の点はストローク中心です<br/>緑の点を移動してストロークの出現位置を調整します',
    },
  },
  layer: {
    title: 'コンポーネントレイヤー',
    maskLayer: 'マスクレイヤー',
    bottomImage: 'ボトムイメージ',
    eraseableTip:
      'このカテゴリでは、すべての画像は消去可能です。<br />右側のスイッチを使用して、デフォルトでの消去の有効化または無効化を制御できます。ここで無効にされた場合でも、特定のタイミングでイベントを使用して再度有効にすることができます。',
    uneraseableTip: 'このカテゴリでは、すべての画像や動画は消去できません。',
    addGroup: 'グループの追加',
    groupName: 'グループ名',
    groupNamePlaceholder: '入力してください。分組の名称を教えてください。',
    groupNameEmptyWarning: 'グループ名は必須です',
    eraseableTitle: '消去の可否',
    eraseable: '消去可',
    uneraseable: '消去不可',
    applyAllAnimation: 'グループ内のすべてのレイヤーに適用',
  },
  event: {
    title: 'イベント検出',
    when: '判断のタイミング',
    upTrigger: '指を離したときの判断',
    erasingTrigger: '消去プロセス中のリアルタイム判断',
    erasingTriggerTip:
      'この設定はパフォーマンスに影響する可能性があります。注意して使用してください。',
    eraseTitleTip:
      '特定の消去可能領域が消去されたときに、イベントがトリガーされます；<br />設定が完了した後、イベント選択に入り、特定の段階に到達するかどうかに応じて具体的な応答イベントを設定します。',
    addEventJudge: 'イベント検出を追加',
    areaSelectTitle: '検出領域の選択',
    selectAreaPlaceholder: '判定区域を選択してください',
    addManageArea: 'カスタム検出領域の追加/管理',
    addStep: '新しいステージ',
    step: 'ステージ',
    stepWarning: '判定領域に重複があります。修正または削除してください。',
    area: {
      title: 'カスタム判定領域',
      addArea: 'カスタム判定領域を追加する',
      editArea: 'カスタム判定領域を編集する',
      areaName: '名前',
      areaNamePlaceholder: '名前を入力してください',
      addRect: '長方形を追加する',
      cancel: 'キャンセル',
      save: '保存',
    },
    stepSelect: 'ステージ選択',
    customEventPlaceholder: 'イベント判定を選択してください',
    stepPlaceholder: 'ステージを選択してください',
    eraseStartTip:
      '有効になっている消去可能グループのレイヤーで指をスライドすると、消去が開始されたと見なされます',
    eraseUpTip: '消去を開始した後に指を離してください',
    eraseReachStepTip:
      '最初に消去設定でイベント判定に対応する判定領域とステージの割合を設定してください',
    eraseUnReachStepTip:
      '最初に消去設定でイベント判定に対応する判定領域とステージの割合を設定してください',
    addHandImage: '指に従って画像を追加する',
    selectActionGroupPlaceholder: '選択する',
    selectHandImagePlaceholder: '選択する',
    selectAnimationPlaceholder: '選択する',
  },
}
